import navBarHomepage from '../modules/navbar-homepage';
import signOut from '../modules/sign_out';
let signoutController = () => {
    navBarHomepage.on();
    signOut.on();
};

export default signoutController;
